<template>
	<div>
		
		<stato-fase
			:fase-with-stati="faseWithStati"
			:pratica="pratica"
			:pratica-diff="praticaDiff"
			@update-id-stato="pratica.id_stato_fase_5 = $event"
			:disabled="isLoading"
			:action="action"
		></stato-fase>
		
		<v-row
			v-if="pratica.id_stato_fase_5 == 191"
			no-gutters
			class="flex-column mt-2"
		>
			<v-col>
				{{ bando.frase_del_link_pubblicazione_esiti_provvisori }}
			</v-col>
			<v-col>
				<a
					:href="bando.link_pubblicazione_esiti_provvisori"
					target="_blank"
				>
					{{ bando.link_pubblicazione_esiti_provvisori }}
				</a>
			</v-col>
		</v-row>

		<template v-if="(pratica.id_stato_fase_5 == 191 && isCliente) || isAccountManager">
			<v-sheet
				rounded
				color="primary"
				class="my-5 px-4 mt-10 text-h6"
			>
				<span class="tertiary--text">
					Esito da Elenco Cronologico
				</span>
			</v-sheet>
			
			<v-row
				class="flex-column text-h6"
				no-gutters
			>
				<v-col>
					Esito: <span class="primary--text">{{ esitoClickday }}</span>
				</v-col>
				<v-col>
					Tempo: <span class="primary--text">{{ tempoClickday }}</span>
				</v-col>
			</v-row>
		</template>
		
		<template v-if="(isAccountManager || isCliente) && pratica.id_stato_fase_5 == 191">
			<v-sheet
				rounded
				color="primary"
				class="my-5 px-4 mt-10 text-h6"
			>
				<span class="tertiary--text">
					Imponibili da fatturare in base all'esito
				</span>
			</v-sheet>
			
			<v-row>
				<v-col cols="6">
					<v-badge
						:value="praticaDiff.includes('importo_da_fatturare')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.importo_da_fatturare"
							@input="pratica.importo_da_fatturare = $event !== '' ? $event : null"
							label="Imponibile da Fatturare Esiti Provvisori"
							outlined
							dense
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
							type="number"
							min="0"
							:rules="[mixin_rules.min0]"
						></v-text-field>
					</v-badge>
				</v-col>
				<v-col cols="6">
					<v-badge
						:value="praticaDiff.includes('importo_da_fatturare_esiti_definitivi')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.importo_da_fatturare_esiti_definitivi"
							@input="pratica.importo_da_fatturare_esiti_definitivi = $event !== '' ? $event : null"
							label="Imponibile da Fatturare Esiti Definitivi"
							outlined
							dense
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
							type="number"
							min="0"
							:rules="[mixin_rules.min0]"
						></v-text-field>
					</v-badge>
				</v-col>
			</v-row>
			
			<!--
				Al momento questi campi sono nascosti ai clienti.
				Se si decidesse di mostrarli, devo renderli visibili solo se
				path_accordo_prenotazione != null || is_partner
			-->
			<template v-if="isAccountManager || isConsulente || isAssociazioneDiCategoria">
				<v-sheet
					rounded
					color="primary"
					class="my-5 px-4 mt-10 text-h6"
				>
				<span class="tertiary--text">
					Imponibili bonus in base all'esito
				</span>
				</v-sheet>
				
				<v-row>
					<v-col cols="6">
						<v-badge
							:value="praticaDiff.includes('importo_bonus_esiti_provvisori')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.importo_bonus_esiti_provvisori"
								@input="pratica.importo_bonus_esiti_provvisori = $event !== '' ? $event : null"
								label="Imponibile Bonus Esiti Provvisori"
								outlined
								dense
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
								type="number"
								min="0"
								:rules="[mixin_rules.min0]"
							></v-text-field>
						</v-badge>
					</v-col>
					<v-col cols="6">
						<v-badge
							:value="praticaDiff.includes('importo_bonus_esiti_definitivi')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.importo_bonus_esiti_definitivi"
								@input="pratica.importo_bonus_esiti_definitivi = $event !== '' ? $event : null"
								label="Imponibile Bonus Esiti Definitivi"
								outlined
								dense
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
								type="number"
								min="0"
								:rules="[mixin_rules.min0]"
							></v-text-field>
						</v-badge>
					</v-col>
				</v-row>
			</template>
			
			<template v-if="isAccountManager">
				<v-row>
					<v-col cols="6">
						<v-btn
							color="secondary"
							@click="calcoloAutomaticoImporti('esiti_provvisori')"
							:disabled="isLoading
								|| pratica.contratto_di_servizio_id === null
								|| pratica.contratto_di_servizio?.tipo_contratto_di_servizio_id === null
								|| esitoClickday != 'Vincente Esiti Provvisori'"
						>
							Calcola imponibili esiti provvisori
						</v-btn>
					</v-col>
					<v-col cols="6">
						<v-btn
							color="secondary"
							@click="calcoloAutomaticoImporti('esiti_definitivi')"
							:disabled="isLoading
								|| pratica.contratto_di_servizio_id === null
								|| pratica.contratto_di_servizio?.tipo_contratto_di_servizio_id === null
								|| esitoClickday != 'Vincente Esiti Definitivi'"
						>
							Calcola imponibili esiti definitivi
						</v-btn>
					</v-col>
					<v-col cols="12">
						<p
							v-if="pratica.contratto_di_servizio_id === null || pratica.contratto_di_servizio?.tipo_contratto_di_servizio_id === null"
							:style="`color:${$vuetify.theme.currentTheme.warning}`"
						>
							I bottoni per il calcolo automatico degli imponibili non sono disponibili,<br>
							assicurati che sia stato associato un Contratto di Servizio e sia stato scelto il Tipo di Contratto di Servizio
						</p>
						<p
							v-else-if="esitoClickday != 'Vincente Esiti Provvisori' && esitoClickday != 'Vincente Esiti Definitivi'"
							:style="`color:${$vuetify.theme.currentTheme.warning}`"
						>
							I bottoni per il calcolo automatico degli imponibili non sono disponibili perché l'esito non è vincente.
						</p>
					</v-col>
				</v-row>
			</template>
		</template>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/event-bus";
export default {
	props: ['value', 'action', 'faseWithStati', 'praticaDiff'],
	data() {
		return {
			pratica: {
				id: null,
				id_stato_fase_5: null,
				ci_sono_aggiornamenti_fase_5: false
			},
			
		}
	},
	
	created() {
		this.isSettingPratica = true;
		// this.pratica = Object.assign({}, this.value);
		this.pratica = this.value;
		this.isSettingPratica = false;
		
		if (this.pratica.ci_sono_aggiornamenti_fase_5 && this.isCliente) {
			this.pratica.ci_sono_aggiornamenti_fase_5 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_fase_5',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_fase_5');
		}
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			isCoordinatore: 'auth/isCoordinatore',
			isConsulente: 'auth/isConsulente',
			isAssociazioneDiCategoria: 'auth/isAssociazioneDiCategoria',
			bando: 'shared/bando',
		}),
		isLoading() {
			return this.isSettingPratica;
		},
		esitoClickday() {
			if (this.pratica.cliccatore_id !== null) {
				return this.pratica.cliccatore.bandi_simulatore[0]?.esito_bando.esito_clickday;
			}
			else return null;
		},
		tempoClickday() {
			if (this.pratica.cliccatore_id !== null) {
				return this.pratica.cliccatore.bandi_simulatore[0]?.esito_bando.tempo_clickday;
			}
			else return null;
		}
	},
	
	watch: {
		pratica: {
			handler(newPratica) {
				if (!this.isLoading) {
					this.$emit('input', newPratica)
				}
			},
			deep: true
		},
		isLoading(newVal) {
			this.$emit('is-loading', newVal)
		},
	},
	
	methods: {
		calcoloAutomaticoImporti(key) {
			axios.post('/api/tipi-contratto-di-servizio/calcolo-importi', {
				pratica_id: this.pratica.id,
				tipo_contratto_di_servizio_id: this.pratica.contratto_di_servizio.tipo_contratto_di_servizio_id
			})
				.then(response => {
					if (key == 'esiti_provvisori') {
						this.pratica.importo_da_fatturare = response.data.importo_fattura;
						this.pratica.importo_bonus_esiti_provvisori = response.data.importo_bonus;
					}
					else if (key == 'esiti_definitivi') {
						this.pratica.importo_da_fatturare_esiti_definitivi = response.data.importo_fattura;
						this.pratica.importo_bonus_esiti_definitivi = response.data.importo_bonus;
					}
				})
		}
	}
	
}
</script>

<style scoped>

</style>